import { formatDistanceToNow } from "date-fns";
import { Filter } from "lucide-react";
import React from "react";
import { Button } from "src/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "src/components/ui/hover-card";

interface InteractiveAlertTagProps {
  type: "category" | "service";
  value: string;
  stats?: { count: number; mostRecent: Date };
  isActive: boolean;
  onClick: () => void;
}

export const InteractiveAlertTag: React.FC<InteractiveAlertTagProps> = ({
  type,
  value,
  stats,
  isActive,
  onClick,
}) => {
  const label = type === "category" ? "Category" : "Service";

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <button
          onClick={onClick}
          className={`
            px-1.5 py-0.5 text-xs rounded whitespace-nowrap overflow-hidden text-ellipsis max-w-xs
            transition-all cursor-pointer
            ${isActive
              ? "bg-primary/30 text-primary border border-primary/50 ring-1 ring-primary/30"
              : "bg-secondary text-foreground border border-border hover:border-border"
            }
          `}
        >
          {label}: {value}
        </button>
      </HoverCardTrigger>
      <HoverCardContent className="w-56" align="start">
        <div className="space-y-3">
          <div>
            <p className="text-sm font-medium text-foreground">
              {label}: {value}
            </p>
            <div className="h-px bg-border mt-2" />
          </div>

          {stats ? (
            <div className="space-y-1 text-sm">
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground">{stats.count}</span>{" "}
                {stats.count === 1 ? "investigation" : "investigations"}
              </p>
              <p className="text-muted-foreground text-xs">
                Most recent: {formatDistanceToNow(stats.mostRecent, { addSuffix: true })}
              </p>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">No statistics available</p>
          )}

          <Button
            variant="outline"
            size="sm"
            onClick={onClick}
            className="w-full gap-2 text-xs"
          >
            <Filter className="h-3 w-3" />
            {isActive ? "Remove filter" : "Filter by this tag"}
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
